module.exports = __webpack_public_path__ + "img/jupiter.7419cdd1.svg";